import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { HeroImage } from "../../../atoms/HeroImage";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { useDeviceType } from "../../../custom-hooks/useDeviceType";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../../utils/story";
import { Label } from "../../../atoms/Label";
import SubHeadline from "../../../atoms/SubHeadline";
import Headline from "../../../atoms/Headline";

import "../four-column-ten-stories.m.css";

const StoryCard = ({ story, showTimeStamp, showReadTime, showSubHeadline, index, sectionSlug }) => {
  const deviceType = useDeviceType();

  let iconSizes = { height: 32, width: 32 };
  if (deviceType === "desktop") {
    if (index === 0) {
      iconSizes = { height: 48, width: 48 };
    }
  } else if (deviceType === "tablet") {
    if (index === 0) {
      iconSizes = { height: 48, width: 48 };
    }
  } else if (deviceType === "mobile") {
    if (index === 0) {
      iconSizes = { height: 48, width: 48 };
    } else if (index <= 3) {
      iconSizes = { height: 24, width: 24 };
    }
  }
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target}>
      <div styleName="card">
        <div styleName="image">
          <HeroImage story={story} aspectRatio={[[4, 3]]} iconSizes={iconSizes} />
        </div>
        <div styleName="story-details">
          {label && <Label story={story} />}

          {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
          {showSubHeadline && story?.subheadline && (
            <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
          )}
          <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />
        </div>
      </div>
    </Link>
  );
};

StoryCard.propTypes = {
  story: PropTypes.shape({
    slug: PropTypes.string,
    subheadline: PropTypes.string,
  }),
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  showSubHeadline: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default StoryCard;
